<div class="timeline-view">
  <ng-container *ngIf="items && items.length > 0">
  <h3>Timeline</h3>
  <div class="timeline-container modern-scroll">
    <div class="timeline flex flex--column">
        <div *ngFor="let item of items">
          <div class="timeline--circle">
            <div class="timeline--item">
              <div class="timeline--personName">{{ item?.personName }}</div>
              <div class="timeline--date">{{ item?.date }}</div>
              <div class="timeline--description">
                {{ item?.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!(items && items.length > 0)">
    <div>There are no items</div>
  </ng-container>
</div>